import { useMatch as useMatchBase } from 'react-router-dom';
/**
 * React Router の useMatch をラップしたカスタムフック
 * https://reactrouter.com/en/main/hooks/use-match
 */
export const useMatch = useMatchBase;
